import React from 'react';

type Status = 'published' | 'submitted' | 'draft' | 'pending';

interface StatusBadgeProps {
  status: Status;
  count?: number;
  size?: 'small' | 'medium' | 'large';
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, count, size = 'medium' }) => {
  const getStatusConfig = (status: Status) => {
    switch (status) {
      case 'published':
        return {
          bg: '#e8f5e9',
          color: '#2d7a3d',
          icon: '✓',
          label: 'Published',
        };
      case 'submitted':
        return {
          bg: '#e3f2fd',
          color: '#1976d2',
          icon: '↑',
          label: 'Submitted',
        };
      case 'draft':
        return {
          bg: '#fff3e0',
          color: '#f57c00',
          icon: '📝',
          label: 'Draft',
        };
      case 'pending':
        return {
          bg: '#f3f3f3',
          color: '#757575',
          icon: '⏳',
          label: 'Pending',
        };
    }
  };

  const getSizeConfig = (size: 'small' | 'medium' | 'large') => {
    switch (size) {
      case 'small':
        return {
          padding: '3px 10px',
          fontSize: 11,
          iconSize: 12,
        };
      case 'medium':
        return {
          padding: '5px 14px',
          fontSize: 13,
          iconSize: 14,
        };
      case 'large':
        return {
          padding: '8px 18px',
          fontSize: 15,
          iconSize: 16,
        };
    }
  };

  const statusConfig = getStatusConfig(status);
  const sizeConfig = getSizeConfig(size);

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: sizeConfig.padding,
        background: statusConfig.bg,
        color: statusConfig.color,
        borderRadius: 4,
        fontSize: sizeConfig.fontSize,
        fontWeight: 700,
      }}
    >
      <span style={{ fontSize: sizeConfig.iconSize }}>{statusConfig.icon}</span>
      <span>{statusConfig.label}</span>
      {count !== undefined && (
        <span
          style={{
            marginLeft: 4,
            padding: '1px 6px',
            background: statusConfig.color,
            color: '#fff',
            borderRadius: 10,
            fontSize: sizeConfig.fontSize - 2,
          }}
        >
          {count}
        </span>
      )}
    </div>
  );
};
